module.exports = __webpack_public_path__ + "media/images/s01_03-eaafbac3b86c265525b4f6983230e159.svg";